import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EmployeeAuthService } from '../services/employee-auth.service';

/**
 * Guard que verifica si el empleado autenticado es también owner (is_owner = true)
 * Redirige al dashboard si no es owner
 */
export const ownerOnlyGuard: CanActivateFn = (route, state) => {
  const employeeAuthService = inject(EmployeeAuthService);
  const router = inject(Router);
  
  console.log('🔒 Owner-Only Guard - Verificando acceso...');
  
  // Usar el servicio que tiene el BehaviorSubject actualizado
  const employee = employeeAuthService.getCurrentEmployee();
  
  console.log('👤 Empleado actual:', employee);
  console.log('👑 Es owner:', employee?.is_owner);
  
  if (employee && employee.is_owner) {
    console.log('✅ Acceso permitido - Es owner');
    return true;
  }
  
  console.warn('⛔ Acceso denegado - No es owner, redirigiendo al dashboard');
  // Si no es owner, redirigir al dashboard normal
  router.navigate(['/app/dashboard']);
  return false;
};
